import React from "react";
import { Chip } from "@mui/material";

const statusConfig = {
	recebido: { label: "Recebido", color: "#2196f3", bg: "#2196f315" },
	em_analise: { label: "Em Análise", color: "#f5a623", bg: "#f5a62315" },
	aprovado: { label: "Aprovado", color: "#16a34a", bg: "#16a34a15" },
	rejeitado: { label: "Rejeitado", color: "#dc2626", bg: "#dc262615" },
	repasse: { label: "Repasse", color: "#1a9e8f", bg: "#1a9e8f15" },
	consolidacao: { label: "Consolidação", color: "#2196f3", bg: "#2196f315" },
	transformacao: { label: "Transformação", color: "#9c27b0", bg: "#9c27b015" },
};

function StatusBadge({ status }) {
	const config = statusConfig[status] || { label: status, color: "#8e9bae", bg: "#8e9bae15" };
	return (
		<Chip
			label={config.label}
			size="small"
			variant="outlined"
			sx={{
				fontSize: "0.7rem",
				fontWeight: 500,
				height: 24,
				bgcolor: config.bg,
				color: config.color,
				borderColor: `${config.color}30`,
			}}
		/>
	);
}

export default StatusBadge;
